export default "__VITE_ASSET__fb831fec__"